import { useModal } from '../../contexts/ModalContext';

export default function Welcome() {
    const { openLoginModal } = useModal();

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-indigo-50">
            {/* Hero Section */}
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex flex-col items-center justify-center min-h-screen text-center py-20">
                    {/* Main Heading */}
                    <h1 className="text-[52px] font-bold text-gray-900 mb-6 leading-tight">
                        Choose the right courses—faster, smarter, and stress-free.
                    </h1>
                    
                    {/* Subheading */}
                    <p className="text-lg sm:text-xl text-gray-600 mb-12 max-w-3xl">
                        Find courses that meet your academic requirements—effortlessly.
                    </p>
                    
                    {/* CTA Button */}
                    <button
                        onClick={openLoginModal}
                        className="px-8 py-4 bg-blue-600 text-white text-lg font-semibold rounded-full hover:bg-blue-700 transition-colors duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
                    >
                        Get Started
                    </button>
                </div>
            </div>
        </div>
    );
}
